document.addEventListener('DOMContentLoaded', function () {
  // Animate the store title, letter by letter
  document.querySelectorAll('.header__heading-link .h2').forEach(function (el) {
    var text = el.textContent;
    el.textContent = '';
    text.split('').forEach(function (char, i) {
      var span = document.createElement('span');
      span.className = 'site-title-letter';
      span.style.animationDelay = i * 0.08 + 's';
      span.textContent = char === ' ' ? '\u00A0' : char;
      el.appendChild(span);
    });
  });

  // Falling kitchen utensils background
  var icons = ['🍴', '🥄', '🍳', '🥢', '🔪'];
  var container = document.createElement('div');
  container.id = 'kitchen-falling-utensils';
  document.body.appendChild(container);

  var count = 24;
  for (var i = 0; i < count; i++) {
    var span = document.createElement('span');
    span.className = 'kitchen-utensil';
    span.textContent = icons[Math.floor(Math.random() * icons.length)];
    span.style.left = Math.random() * 100 + 'vw';
    span.style.fontSize = 16 + Math.random() * 20 + 'px';
    span.style.animationDuration = 8 + Math.random() * 10 + 's';
    span.style.animationDelay = Math.random() * 10 + 's';
    container.appendChild(span);
  }
});
